import Loader from "react-loader-spinner";
import { Fragment, useEffect, useRef, useState } from "react";
import { Alert, Button, Card, Col, Form, FormGroup, OverlayTrigger, Popover, Row, Table } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelopeOpenText, faTimes } from "@fortawesome/free-solid-svg-icons";
import ModalSelectCustomer from "../../Components/Modals/ModalSelectCustomer";
import { useForm } from "react-hook-form";
import { Archive, CheckLg, CloudUploadFill, Download, EnvelopePlus, ExclamationTriangle, Link45deg, List, Pen, Pencil, PersonCheckFill, Printer, Reply, Search, Trash } from "react-bootstrap-icons";
import DatePicker from "react-datepicker2";
import momentJalaali from "moment-jalali";
import {
    AddMessageRelation, addEditInterOfficeMessage, deleteMessageRelation, getInterOfficeMessage, getLetterTemplateList, getMessagePriorityList,
    getMessageRealNumber, getMessageRelationTypes, searchMessageForSelect, registerInterOfficeMessage, changeMessageStatus,
    attachSignature
} from "../store/api/MessagesAPI";
import { downloadFile, attachFile, getAttachmentList, deleteAttachment, isWebApp, setDialog, keyIsLetterOrNumber, useIsMobileApp } from "../../store/api/CommonFunctions";
import { useHistory } from "react-router-dom";
import { setErrorDialog } from "../../store/api/CommonFunctions";
import { useDispatch } from "react-redux";
import ModalReferDocument from "../../Components/Modals/ModalReferDocument";
import BihamtaTable from "../../Components/BihamtaTable";
import ModalSelectUser from "../../Components/Modals/ModalSelectUser";
import { letterStatus } from "../store/api/CommonAPI";

const AddEditInterOfficeMessage = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const maxDate = momentJalaali();
    const isMobile = useIsMobileApp();
    const inputAttach = useRef();
    const inputSearchLetter = useRef();
    const newRelation = useRef({});
    const [relationError, setRelationError] = useState(null);
    const [message, setMessage] = useState({});
    const [selectedMsg, setSelectedMsg] = useState(null);
    const [messageList, setMessageList] = useState(null);
    const [attachList, setAttachList] = useState(null);
    const [modalReferDoc, setModalReferDoc] = useState({ Show: false });
    const { messageID, messageType, isInternal } = useParams();
    const customerTitle = messageType?.toLowerCase() === "in" ? "فرستنده" : "گیرنده";
    const title = (Number(messageID) > 0 ? "ویرایش " : "ثبت ") + "نامه " + (messageType === "In" ? "وارده" : "صادره") + (JSON.parse(isInternal) ? " داخل سازمان" : "");
    const [popCustomer, setPopCustomer] = useState({ show: false });
    const [priorityList, setPriorityList] = useState(null);
    const { register, handleSubmit, errors } = useForm();
    const [templateList, setTemplateList] = useState(null);
    const [showPopSearchMsg, setShowPopMsg] = useState(false);
    const [relationTypeList, setRelationTypeList] = useState(null);
    const [modalUser, setModalUser] = useState({ show: false });

    function showModalCustomer(e) {
        const onSelectCustomer = (data) => {
            if (data) {
                setMessage({ ...message, CustomerCat: data.Cat, CustomerID: data.ID, CustomerName: data.Name });
            }
        }
        setPopCustomer({
            show: true, value: e.key, invoiceCustomers: true,
            setCustomerData: onSelectCustomer
        });
    }
    function onCustomerTextChanged(e) {
        setMessage({ ...message, CustomerID: null, CustomerCat: null, CustomerName: e.target.value });
    }
    function submitMessage(data) {
        data.MessageDate = message.MessageDate;
        data.MessageType = messageType;
        data.CustomerCat = message.CustomerCat;
        data.CustomerID = message.CustomerID;
        data.IsInternal = isInternal;
        //ممکن است کاربر بلافاصله پس از انتخاب قالب متفاوت بخواهد نامه را چاپ کند
        message.TemplateID = data.TemplateID;
        //
        data.ID = messageID;
        const onAddEdit = (res) => {
            if (res.Data) {
                if (!(Number(messageID) > 0)) {
                    setErrorDialog(dispatch, "success", "ثبت نامه");
                    history.push(`/Office/AddEditInterOfficeMessage/${messageType}/${res.Data}/${isInternal}`);
                }
                else {
                    setErrorDialog(dispatch, "success", "ویرایش نامه");
                }
            }
            else if (res.Error) {
                setErrorDialog(dispatch, res.Error, "ثبت/ویرایش نامه");
            }
        }
        addEditInterOfficeMessage(data, onAddEdit);
    }
    function printLetterTemplate() {

        history.push({
            pathname: `/PrintViewer/LetterTemplate/true`,
            state: {
                dataUrl: "",
                method: "get",
                jsonObject: {
                    PMessageDate: "1402/01/01",
                    Message: " ",
                    Subject: " ",
                    CustomerName: " ",
                    HasAttachment: false,
                    RegisterNumber: " "
                }
            }
        });
    }
    function printLetter(e) {
        history.push({
            pathname: `/PrintViewer/${message.TemplateID}/${e.ctrlKey}`,
            state: {
                dataUrl: "",
                method: "get",
                jsonObject: message
            }
        });
    }
    function attach() {
        dispatch(attachFile(inputAttach.current, messageID, "LetterAttachment", () => getAttachmentList(messageID, "LetterAttachment", setAttachList)));
    }
    function loadAttachList() {
        if (attachList === null) {
            getAttachmentList(messageID, "LetterAttachment", setAttachList);
        }
    }
    function delAttach(id) {
        dispatch(deleteAttachment(id, "LetterAttachment", () => getAttachmentList(messageID, "LetterAttachment", setAttachList)));
    }
    function searchMsg(e) {
        if (e.key && e.key !== "Enter") {
            return;
        }
        setMessageList("PENDING");
        const onSearchDone = (res) => {
            if (res.Data) {
                setMessageList(res.Data);
            }
        }
        searchMessageForSelect(inputSearchLetter.current.value, onSearchDone);
    }
    function selectMsg(row) {
        setSelectedMsg(row);
        setShowPopMsg(false);
    }
    function showModalReferDoc() {
        setModalReferDoc({
            show: true,
            documentID: messageID,
            documentHardCode: "InterOfficeMessage_" + messageType,
            filterOnCurrentUser: true,
            onRefer: getMessage
        })
    }
    function addRelation() {
        setRelationError(null);
        if (!selectedMsg?.ID) {
            setRelationError("نامه ای انتخاب نشده است.");
            return;
        }
        if (!(Number(newRelation.current.RelationTypeID) > 0)) {
            setRelationError("نوع ارتباط انتخاب نشده است.");
            return;
        }
        const isDup = message.Relations.Data.some(r => Number(r.SourceMessageID) === Number(selectedMsg.ID))
        if (Number(selectedMsg.ID) === Number(messageID) || isDup) {
            setRelationError("نامه انتخاب شده با نامه کنونی برابر است یا پیش از این انتخاب شده است.");
            return;
        }
        const data = {
            SourceMessageID: selectedMsg.ID,
            DestMessageID: messageID,
            RelationTypeID: newRelation.current.RelationTypeID,
            RelationDesc: "نامه شماره " + message.RealNumber +
                relationTypeList.Data.find(r => Number(r.ID) === Number(newRelation.current.RelationTypeID))?.InfoName +
                " نامه شماره" + selectedMsg.RealNumber
        }
        const onAdd = (res) => {
            if (res.Data) {
                newRelation.current = {};
                setSelectedMsg(null);
                getMessage();
            }
        }
        AddMessageRelation(data, onAdd);
    }
    function getMessage() {
        const onGet = (res) => {
            if (res.Data) {
                //For BihamtaTable DataList
                res.Data.ReferList = { Data: res.Data.ReferList };
                res.Data.Relations = { Data: res.Data.Relations };
                //
                setMessage(res.Data);
            }
            else if (res.Error) {
                setErrorDialog(dispatch, res.Error, "نامه های اداری");
            }
            else {
                setMessage("PENDING");
            }
        }
        getInterOfficeMessage(messageID, onGet);
    }
    function deleteRel(row) {
        const onDelete = (res) => {
            if (res.Error) {
                setRelationError(res.Error);
            }
            else {
                getMessage();
            }
        }
        deleteMessageRelation(row.RelationID, messageID, onDelete);
    }
    function registerMsg() {
        if (!message.RegisterByID || !message.RegisterDate) {
            return;
        }
        const onRegister = (res) => {
            if (res.Data) {
                getMessage();
            }
            else if (res.Error) {
                setErrorDialog(dispatch, res.Error, "ثبت در اندیکاتور");
            }
        }
        registerInterOfficeMessage(messageID, message.RegisterByID, message.RegisterDate, onRegister);
    }
    function showModalUser(e) {
        if (e.key && !keyIsLetterOrNumber(e.keyCode, e.key)) {
            return;
        }
        const selectUser = (user) => {
            if (user?.ID) {
                setMessage({ ...message, RegisterByID: user.ID, RegisteredByName: user.Name });
            }
        }
        setModalUser({
            show: true,
            selectUserWithName: selectUser
        })
    }
    function changeArchive() {
        let status = "Archived";
        if (Number(message.MessageStatusCode) === letterStatus.Archived) {
            if (message.ReferList?.Data?.length > 0) {
                status = "Refer";
            }
            else if (message.RegisterDate) {
                status = "Registered";
            }
            else {
                status = "Draft";
            }
        }
        changeMessageStatus(messageID, status, getMessage);
    }
    function signMessage() {
        const onSign = (res) => {
            if (res.Error) {
                setErrorDialog(dispatch, res.Error, "ثبت امضا");
            }
            else if (res.Data) {
                setErrorDialog(dispatch, "success", "ثبت امضا");
                getMessage();
            }
        }
        attachSignature(messageID, onSign);
    }
    const popover = (
        (<Popover id="popover-basic" style={{ maxWidth: "500px", minWidth: "500px", fontFamily: "Vazir" }}>
            <Popover.Title as="h3" className="headerStyle">
                <List size={18
                } />&nbsp;
                پیوست ها
            </Popover.Title>
            <Popover.Content className="bodyStyle" style={{ color: "#2c2c71", padding: "10px" }}>
                <FormGroup>
                    <input type="file" className="form-control" ref={inputAttach} />
                    <Button className="btn-input-tiny" style={{ top: "1px", left: "1px" }} onClick={attach}><CloudUploadFill size={25} /></Button>
                </FormGroup>
                <Table responsive className="mt-2 fixedTable scrolledTable">
                    <thead>
                        <tr>
                            <th style={{ width: "25%" }}>تاریخ پیوست</th>
                            <th style={{ width: "50%" }}>نام فایل پیوست</th>
                            <th style={{ width: "25%" }}>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        {attachList === "PENDING" &&
                            <tr>
                                <td colSpan={3} style={{ width: "100%", textAlign: "center" }}><Loader type="BallTriangle" color="#bb1370" width={20} height={20} /></td>
                            </tr>}
                        {
                            attachList && Array.isArray(attachList) &&
                            attachList.map((atc, i) =>
                                <tr key={i} className="resultTableRow">
                                    <td style={{ width: "20%" }}>{atc.PAttachDate}</td>
                                    <td style={{ width: "65%", direction: "ltr" }}>{atc.AttachFileName}</td>
                                    <td style={{ width: "15%" }}>
                                        <Download size={18} color="blue" className="rowBtn" onClick={() => downloadFile(atc.ID, "LetterAttachment")} />&nbsp;&nbsp;
                                        <Trash size={18} color="red" className="rowBtn" onClick={() => delAttach(atc.ID)} />
                                    </td>
                                </tr>)
                        }
                    </tbody>
                </Table>
            </Popover.Content>
        </Popover>))
    const popSearchMsg = (
        (<Popover style={{ maxWidth: "500px", minWidth: "500px", fontFamily: "Vazir" }}>
            <Popover.Title as="h3" className="headerStyle">
                <span><List size={18} />&nbsp;انتخاب نامه</span>
                <FontAwesomeIcon style={{ float: "left" }} icon={faTimes} size="lg" onClick={() => setShowPopMsg(false)} />
            </Popover.Title>
            <Popover.Content className="bodyStyle" style={{ color: "#2c2c71", padding: "10px" }}>
                <FormGroup className="mb-2">
                    <Form.Control ref={inputSearchLetter} placeholder="شماره نامه/شماره ثبت" onKeyDown={searchMsg} />
                    <Button className="btn-input-tiny" style={{ top: 3, left: 3 }} onClick={searchMsg}><Search size={21} /></Button>
                </FormGroup>
                <Table responsive className="mt-0 fixedHeightTable" style={{ whiteSpace: "nowrap" }}>
                    <thead>
                        <tr>
                            <th style={{ width: "20%" }}>موضوع</th>
                            <th style={{ width: "25%" }}>فرستنده/گیرنده</th>
                            <th style={{ width: "15%" }}>شماره نامه</th>
                            <th style={{ width: "15%" }}>تاریخ نامه</th>
                            <th style={{ width: "15%" }}>شماره ثبت</th>
                            <th style={{ width: "10%" }}>داخلی</th>
                        </tr>
                    </thead>
                    <tbody>
                        {attachList === "PENDING" &&
                            <tr>
                                <td colSpan={4} style={{ width: "100%", textAlign: "center" }}><Loader type="BallTriangle" color="#bb1370" width={20} height={20} /></td>
                            </tr>}
                        {
                            Array.isArray(messageList ?? "") &&
                            messageList.map((msg, i) =>
                                <tr key={i} className="resultTableRow" onClick={() => selectMsg(msg)}>
                                    <td style={{ width: "20%" }}>{msg.Subject}</td>
                                    <td style={{ width: "25%" }}>{msg.CustomerName}</td>
                                    <td style={{ width: "15%" }}>{msg.RealNumber}</td>
                                    <td style={{ width: "15%" }}>{msg.PMessageDate}</td>
                                    <td style={{ width: "15%" }}>{msg.RegisterNumber}</td>
                                    <td style={{ width: "10%" }}><input type="checkbox" className="form-check-input" checked={msg.isInternal} readOnly /></td>
                                </tr>)
                        }
                    </tbody>
                </Table>
            </Popover.Content>
        </Popover>))
    const tableColsRefer = [
        { colTitle: "ردیف", colName: "RowNumber" },
        { colTitle: "تاریخ ارجاع", colName: "PEnterDate" },
        { colTitle: "کاربر", colName: "UserName" },
        { colTitle: "شرح ارجاع", colName: "ReferDescription" }
    ]
    const tableColsRel = [
        { colTitle: "ردیف", colName: "RowNumber" },
        { colTitle: "شرح ارتباط", colName: "RelationDesc" }
    ]
    const buttonRels = [
        {
            title: "حذف ارتباط", type: "delete", className: "group-Btn-smalll btn-danger", onclick: (item) => {
                dispatch(setDialog({
                    status: 'show',
                    arrayBtn: ['yes', 'no'],
                    dialogTitle: 'حذف ارتباط',
                    dialogText: 'آیا از حذف مطمئن هستید؟',
                    okOperation: () => deleteRel(item)
                }))
            }
        }
    ]

    useEffect(() => {
        document.body.classList = "notMain";
        document.title = "بی همتا-اداری";
        getMessagePriorityList(setPriorityList);
        getLetterTemplateList(setTemplateList);
        if (messageType === "Out" && !(Number(messageID) > 0)) {
            const onGetNumber = (res) => {
                if (res.Data) {
                    setMessage({ MessageDate: momentJalaali().local("en").format("YYYY-MM-DD"), RealNumber: res.Data });
                }
                else if (res.Error) {
                    setErrorDialog(dispatch, res.Error, "نامه های اداری");
                    setMessage({});
                }
            }
            setMessage("PENDING");
            getMessageRealNumber(onGetNumber);
        }
        else if (!(Number(messageID) > 0)) {
            setMessage("PENDING");
            setTimeout(() => { setMessage({ MessageDate: momentJalaali().local("en").format("YYYY-MM-DD") }); }, 10)

        }
        else if (Number(messageID) > 0) {
            getMessageRelationTypes(setRelationTypeList);
            getMessage();
        }
    }, [messageType, messageID])
    return (
        <div className="container-fluid mt-1" style={{ textAlign: "right" }}>
            <br />
            <Card >
                <ModalSelectCustomer popData={popCustomer} setCustomerPopup={setPopCustomer} />
                {Number(messageID) > 0 &&
                    <Fragment>
                        <ModalReferDocument popData={modalReferDoc} setPopData={setModalReferDoc} />
                        <ModalSelectUser popData={modalUser} setUserPop={setModalUser} />
                    </Fragment>
                }
                <Card.Header className="headerStyle">
                    <FontAwesomeIcon icon={faEnvelopeOpenText} size="lg" />&nbsp;
                    {title} {(message.MessageStatusName ?? "") !== "" ? `[وضعیت: ${message.MessageStatusName}]` : ""}
                    {message?.CreateByName && <span style={{ float: "left", fontSize: "12px" }}><PersonCheckFill size={16} /> {message.CreateByName}</span>}
                </Card.Header>
                <Card.Body className="bodyStyle">
                    {message === "PENDING" && <div style={{ textAlign: "center" }}><Loader type="BallTriangle" width={25} height={25} color="#bb1370" /></div>}
                    {message && message !== "PENDING" &&
                        <Fragment>
                            <form onSubmit={handleSubmit(submitMessage)}>
                                <Row className="rowBorder">
                                    {!JSON.parse(isInternal) &&
                                        <Col md={2} className="form-group">
                                            <label>{customerTitle}:</label>
                                            <Form.Control ref={register({ required: true })} name="CustomerName" onChange={onCustomerTextChanged}
                                                value={message?.CustomerName ?? ""} />
                                            <Button className="btn-input-tiny" onClick={showModalCustomer} style={{ top: 25 }}><List size={23} /></Button>
                                        </Col>}
                                    <Col md={2} className="form-group">
                                        <label className="ellipsisLabel">شماره نامه:</label>
                                        <Form.Control name="RealNumber" ref={register({ required: true })} defaultValue={message?.RealNumber ?? ""} readOnly={messageType === "Out"} />
                                        {errors?.RealNumber && <span className="errors">شماره نامه الزامی است</span>}
                                    </Col>
                                    <Col md={1} className="form-group">
                                        <label className="ellipsisLabel"><span style={{ color: "red" }}>*</span>&nbsp;تاریخ نامه:</label>
                                        <DatePicker className="form-control" timePicker={false} isGregorian={false} onChange={val => setMessage({ ...message, MessageDate: val.local("en").format("YYYY-MM-DD") })}
                                            value={message?.MessageDate ? momentJalaali(message.MessageDate.substring(0, 10)) : null} max={maxDate} />
                                    </Col>
                                    <Col md={1} className="form-group">
                                        <label className="ellipsisLabel"><span style={{ color: "red" }}>*</span>&nbsp;اولویت:</label>
                                        {Array.isArray(priorityList?.Data ?? "") ?
                                            <select className="form-control" ref={register({ required: true })} name="Priority" defaultValue={message.Priority}>
                                                <option value="">انتخاب کنید</option>
                                                {priorityList.Data.map((item, i) =>
                                                    <option value={item.ID} key={i}>{item.InfoName}</option>)
                                                }
                                            </select> :
                                            <div className="form-control">
                                                <Loader type="BallTriangle" width={20} height={20} color="#bb1370" />
                                            </div>
                                        }
                                        {errors?.Priority && <span className="errors">انتخاب اولویت الزامی است</span>}
                                    </Col>
                                    {Number(messageID) > 0 &&
                                        <Col md={1} className="form-group">
                                            <label className="ellipsisLabel"><span style={{ color: "red" }}>*</span>&nbsp;تعداد پیوست:</label>
                                            <Form.Control type="number" name="AttachmentCount" ref={register({ required: true })} defaultValue={message?.AttachmentCount ?? "0"} />
                                            {errors?.AttachmentCount}
                                        </Col>
                                    }
                                </Row>
                                <Row className="rowBorder" style={{ marginTop: "2px" }}>
                                    <Col md={2} className="form-group">
                                        <label>قالب نامه:</label>
                                        {templateList?.Data ?
                                            <select className="form-control" ref={register({ required: "true" })} name="TemplateID" defaultValue={message.TemplateID}>
                                                {templateList.Data.map((item, i) =>
                                                    <option value={item} key={i}>{item}</option>)}
                                            </select> :
                                            <div className="form-control">
                                                <Loader width={20} height={20} color="#bb1370" type="BallTriangle" />
                                            </div>
                                        }
                                    </Col>
                                    <Col md={3} className="form-group">
                                        <span style={{ color: "red" }}>*</span> <label>موضوع:</label>
                                        <Form.Control name="Subject" ref={register({ required: true })} defaultValue={message?.Subject ?? ""} />
                                        {errors?.Subject && <span className="errors">موضوع نامه الزامی است</span>}
                                    </Col>
                                    <Col md={12} className="form-group">
                                        <span style={{ color: "red" }}>*</span> <label>متن: </label>
                                        <Form.Control as="textarea" rows={5} name="Message" ref={register({ required: true })} defaultValue={message?.Message ?? ""} />
                                        {errors?.Message && <span className="errors">متن نامه الزامی است</span>}
                                    </Col>
                                </Row>
                                <div className="mt-1">
                                    <Button className="group-Btn-large" type="submit" variant="success" disabled={Number(messageID) > 0 && Number(message.MessageStatusCode) !== letterStatus.Draft}>
                                        {Number(messageID) > 0 ?
                                            <Fragment>
                                                <Pencil size={16} /> ویرایش نامه
                                            </Fragment> :
                                            <Fragment>
                                                <CheckLg size={18} /> ثبت نامه
                                            </Fragment>

                                        }
                                    </Button>
                                    {Number(messageID) > 0 &&
                                        <Fragment>
                                            {(Number(message.MessageStatusCode) === letterStatus.Refer ||
                                                Number(message.MessageStatusCode) === letterStatus.Archived ||
                                                Number(message.MessageStatusCode) === letterStatus.Registered) &&
                                                <Button onClick={changeArchive} className="group-Btn-large">
                                                    <Archive size={16} />&nbsp;
                                                    {
                                                        Number(message.MessageStatusCode) === letterStatus.Archived ?
                                                            "خروج از بایگانی" : "بایگانی"
                                                    }
                                                </Button>
                                            }
                                            <Button variant="secondary" className="group-Btn-large" onClick={printLetter}><Printer size={18} />&nbsp;چاپ نامه</Button>
                                            {!isMobile &&
                                                <Fragment>
                                                    <OverlayTrigger trigger="click" placement="top" overlay={popover} rootClose>
                                                        <Button variant="light" className="group-Btn-large btn-violet" onClick={loadAttachList}><Link45deg size={19} />&nbsp;پیوست ها</Button>
                                                    </OverlayTrigger>
                                                    <Button variant="info" className="group-Btn-large" onClick={signMessage}>
                                                        <Pen size={18} />&nbsp;{message.SignatureFileName?.length > 0 ? 'تغییر امضا' : 'امضای نهایی'}
                                                    </Button>
                                                </Fragment>
                                            }
                                        </Fragment>
                                    }
                                    {!isMobile && <Button className="group-Btn-large" onClick={printLetterTemplate}><EnvelopePlus size={18} />  قالب نامه جدید</Button>}
                                </div>
                            </form>

                            {Number(messageID) > 0 && !isMobile &&
                                <Fragment>
                                    {!JSON.parse(isInternal) &&
                                        <Row className="rowBorder mt-5"  >
                                            <div className="rowTitle">ثبت در اندیکاتور</div>
                                            <Col md={2} className="form-group">
                                                <label>کاربر ثبت کننده</label>
                                                <Form.Control readOnly value={message.RegisteredByName} onKeyDown={showModalUser} />
                                                <Button className="btn-input-tiny" onClick={showModalUser}><List size={21} /></Button>
                                            </Col>
                                            <Col md={2} className="form-group">
                                                <label>تاریخ ثبت: </label>
                                                <DatePicker timePicker={false} isGregorian={false} className="form-control" value={message?.RegisterDate ? momentJalaali(message.RegisterDate.substring(0, 10)) : null}
                                                    onChange={value => message.RegisterDate = value.local("en").format("YYYY-MM-DD")} max={momentJalaali()} />
                                            </Col>
                                            <Col md={2} className="form-group">
                                                <label>شماره ثبت: </label>
                                                <Form.Control defaultValue={message?.RegisterNumber ?? ""} onChange={e => message.RegisterNumber = e.target.value} />
                                            </Col>
                                            {(message.RegisterNumber ?? "") === "" &&
                                                <Col md={2} style={{ display: "flex", alignItems: "flex-end", paddingBottom: "2px" }}>
                                                    <Button className="group-Btn" variant="success" onClick={registerMsg}><CheckLg size={17} />&nbsp;ثبت در اندیکاتور</Button>
                                                </Col>
                                            }
                                        </Row>
                                    }
                                    <Row className="mt-4" style={{ margin: 0 }}>
                                        <Col md={6} className="rowBorder">
                                            <div className="rowTitle">ارجاع ها</div>
                                            <Button className="group-Btn mt-3" variant="info" onClick={showModalReferDoc}><Reply size={16} />&nbsp; ارجاع به کاربر</Button>
                                            <BihamtaTable columns={tableColsRefer} fixedHeightTable style={{ whiteSpace: "nowrap" }} dataList={message.ReferList} />
                                        </Col>
                                        <Col md={6} className="rowBorder">
                                            <div className="rowTitle">ارتباط ها</div>
                                            <Row>
                                                <Col md={4} className="form-group">
                                                    <label>نوع ارتباط: </label>
                                                    {relationTypeList?.Data ?
                                                        <select className="form-control" onChange={e => newRelation.current.RelationTypeID = e.target.value}>
                                                            <option value="">انتخاب کنید</option>
                                                            {relationTypeList.Data.map((item, i) =>
                                                                <option value={item.ID} key={i}>{item.InfoName}</option>)}
                                                        </select> :
                                                        <div className="form-control">
                                                            <Loader width={20} height={20} color="#bb1370" type="BallTriangle" />
                                                        </div>
                                                    }
                                                </Col>
                                                <Col md={4} className="form-group">
                                                    <label>شماره نامه: </label>
                                                    <Form.Control readOnly value={selectedMsg?.RealNumber ?? ""} />
                                                    <OverlayTrigger trigger="none" placement="top" overlay={popSearchMsg} show={showPopSearchMsg}>
                                                        <Button className="btn-input-tiny" onClick={() => setShowPopMsg(true)}><List size={21} /></Button>
                                                    </OverlayTrigger>
                                                </Col>
                                                <Col md={4} style={{ display: "flex", alignItems: "flex-end", paddingBottom: "2px" }}>
                                                    <Button className="group-Btn" variant="success" onClick={addRelation}><CheckLg size={16} />&nbsp;ثبت ارتباط</Button>
                                                </Col>
                                            </Row>
                                            <BihamtaTable columns={tableColsRel} rowButtons={buttonRels} dataList={message.Relations} fixedHeightTable style={{ whiteSpace: "nowrap" }} />
                                            {relationError &&
                                                <Alert variant="danger">
                                                    <ExclamationTriangle size={18} />&nbsp;
                                                    {relationError}
                                                    <FontAwesomeIcon icon={faTimes} size="lg" onClick={() => setRelationError(null)} style={{ float: "left" }} />
                                                </Alert>
                                            }
                                        </Col>
                                    </Row>
                                </Fragment>
                            }
                        </Fragment>
                    }
                </Card.Body>
            </Card>
        </div>
    )

}
export default AddEditInterOfficeMessage;